import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ru from './locales/ru/translation.json';
import mn from './locales/mn/translation.json';
import en from './locales/en/translation.json';
import workspaceRu from './locales/ru/workspace.json';
import workspaceEn from './locales/en/workspace.json';
import workspaceMn from './locales/mn/workspace.json';

import commerceRu from './locales/ru/commerce.json';
import commerceEn from './locales/en/commerce.json';
import commerceMn from './locales/mn/commerce.json';
import territoryRu from './locales/ru/territory.json';
import territoryEn from './locales/en/territory.json';
import territoryMn from './locales/mn/territory.json';
import administrationRu from './locales/ru/administration.json';
import administrationEn from './locales/en/administration.json';
import administrationMn from './locales/mn/administration.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: { ...ru, administration: administrationRu, territory: territoryRu, commerce: commerceRu, workspace: workspaceRu, calendar: { ...ru.calendar, create: workspaceRu.calendarCreate } } },
      mn: { translation: { ...mn, administration: administrationMn, territory: territoryMn, commerce: commerceMn, workspace: workspaceMn, calendar: { ...mn.calendar, create: workspaceMn.calendarCreate } } },
      en: { translation: { ...en, administration: administrationEn, territory: territoryEn, commerce: commerceEn, workspace: workspaceEn, calendar: { ...en.calendar, create: workspaceEn.calendarCreate } } }
    },
    fallbackLng: 'ru',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
